"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomPipeInfo = void 0;
const boundingBox_1 = require("../boundingBox");
const pipeNode_1 = require("./pipeNode");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
class RoomPipeInfo {
    constructor(startNode, pipeNodeGroups) {
        this._startNode = startNode;
        //this._mainPipes = [];
        //this._mainPipeNodes = [];
        //this.getMainPipesAndNodes(startNode);
        let childNodePoints = [];
        for (let pipeNodeGroup of pipeNodeGroups) {
            for (let childNode of pipeNodeGroup._childPipeNodes) {
                childNodePoints.push(childNode._point);
            }
        }
        this._boundingBox = new boundingBox_1.BoundingBox(childNodePoints);
    }
    IsPassThroughThisRoom(p0, p1) {
        let ltPoint = new Coordinate_js_1.default(this._boundingBox.min.x, this._boundingBox.max.y);
        let lbPoint = new Coordinate_js_1.default(this._boundingBox.min.x, this._boundingBox.min.y);
        let rtPoint = new Coordinate_js_1.default(this._boundingBox.max.x, this._boundingBox.max.y);
        let rbPoint = new Coordinate_js_1.default(this._boundingBox.max.x, this._boundingBox.min.y);
        let boxSegments = [new LineSegment_js_1.default(ltPoint, rtPoint), new LineSegment_js_1.default(rtPoint, rbPoint), new LineSegment_js_1.default(rbPoint, lbPoint), new LineSegment_js_1.default(lbPoint, ltPoint)];
        let currentSegment = new LineSegment_js_1.default(p0, p1);
        let intersectWithBoundingBox = false;
        for (let segment of boxSegments) {
            if (currentSegment.intersection(segment)) {
                intersectWithBoundingBox = true;
                break;
            }
        }
        if (intersectWithBoundingBox === false) {
            return false;
        }
        let roomSegments = new Array;
        this.traverseToGetPipes(this._startNode, roomSegments);
        let intersectWithPipe = false;
        for (let segment of roomSegments) {
            if (currentSegment.intersection(segment)) {
                intersectWithPipe = true;
                break;
            }
        }
        return intersectWithPipe;
    }
    getMainPipeNodes() {
        let mainPipeNodes = [this._startNode];
        this.traverseToGetMainPipeNodes(this._startNode, mainPipeNodes);
        return mainPipeNodes;
    }
    getMainPipes() {
        let mainPipes = new Array();
        this.traverseToGetMainPipes(this._startNode, mainPipes);
        return mainPipes;
    }
    traverseToGetMainPipeNodes(node, mainPipeNodes) {
        for (let child of node._children) {
            if (child._type == pipeNode_1.PipeNodeType.Main) {
                mainPipeNodes.push(child);
                this.traverseToGetMainPipeNodes(child, mainPipeNodes);
            }
        }
    }
    traverseToGetMainPipes(node, mainPipes) {
        for (let child of node._children) {
            if (child._type == pipeNode_1.PipeNodeType.Main) {
                mainPipes.push(new LineSegment_js_1.default(node._point, child._point));
                this.traverseToGetMainPipes(child, mainPipes);
            }
        }
    }
    traverseToGetPipes(node, pipes) {
        for (let child of node._children) {
            pipes.push(new LineSegment_js_1.default(node._point, child._point));
            this.traverseToGetPipes(child, pipes);
        }
    }
}
exports.RoomPipeInfo = RoomPipeInfo;
